import axios from "axios";
import Config from "../../config/index";
import RefreshTokenHandler from "./refresh-token";

const legacyUploaderTXN = async (
    email: string,
    amc_code: string,
    txn_data: any,
) => {
    const url = `${Config.baseUrl}/legacy-uploaders/transactions`;
    try {
        const result: any = await axios.post(
            url,
            {
                email,
                amc_code,
                txn_data
            },
            {
                headers: {
                    Authorization: sessionStorage.getItem("token") || "",
                },
            }
        );
        return result;
    } catch (err: any) {
        if (err.response.data.status == 401) {
            let responseToHandle = err.response.data;
            let result = await RefreshTokenHandler.handleIt(responseToHandle);
            if (result.status) {
                return await legacyUploaderTXN(
                    email,
                    amc_code,
                    txn_data
                );
            } else {
                throw err;
                // return result
            }
        } else {
            throw err;
        }
    }
};

const legacyLedgersUploader = async (
    email: string,
    amc_code: string,
    data: any,
) => {
    const url = `${Config.baseUrl}/legacy-uploaders/ledgers`;
    try {
        const result: any = await axios.post(
            url,
            {
                email,
                amc_code,
                data
            },
            {
                headers: {
                    Authorization: sessionStorage.getItem("token") || "",
                },
            }
        );
        return result;
    } catch (err: any) {
        if (err.response.data.status == 401) {
            let responseToHandle = err.response.data;
            let result = await RefreshTokenHandler.handleIt(responseToHandle);
            if (result.status) {
                return await legacyLedgersUploader(
                    email,
                    amc_code,
                    data
                );
            } else {
                throw err;
                // return result
            }
        } else {
            throw err;
        }
    }
};

export { 
    legacyUploaderTXN,
    legacyLedgersUploader
 };
